import React from 'react';
import { UserModel, userModelInitial } from '../../Models/UserModel';

export interface UserContextProps {
    user: UserModel,
    setUser: (user: UserModel) => void,
    disableSubmit: boolean,
    setDisableSubmit: (value: boolean) => void,
}

export const userContextInitial: UserContextProps = {
    user: userModelInitial,
    setUser: () => { ''; },
    disableSubmit: false,
    setDisableSubmit: () => { ''; },
};

export const UserContext = React.createContext(userContextInitial);